export default __webpack_public_path__ + "static/media/logo.430a80e5.svg";